module.exports = __webpack_public_path__ + "static/media/hoelprogram.b9f9d5d9.png";